import { ProductCoverageName } from "Store/akaAdvice/interfaces/CollectiveAdvice";

export const getInlineDisplayName = (
  productCoverageName: ProductCoverageName,
): string => {
  switch (productCoverageName) {
    case ProductCoverageName.DEATH:
      return "livsforsikring";
    case ProductCoverageName.DISABILITY_FLEX_PENSION:
      return "uføreforsikring";
    case ProductCoverageName.CRITICAL_ILLNESS:
      return "kritisk sykdom";
    default:
      return "forsikringen";
  }
};
